<script lang="ts">
  // MetricCard — reusable KPI tile.
  //
  // Visual reference: openspec/changes/ui-redesign-v2/Untitled.fig
  //   - KpiTotal  (0:83): 180 × 88, fill #12151A, label ALL CAPS +
  //     big mono value
  //   - KpiHealthy / KpiUnhealthy (0:86, 0:93): same with status dot
  //   - KpiUptime (0:99): same with mono percent value
  //   - HostOverview MetricsGrid (0:104-148): 3 metric tiles per row
  //     including sparklines + trend arrows
  //
  // The component is purely presentational — it takes pre-formatted
  // strings so the page-level store subscriber decides when to
  // re-render. Sparkline is optional via the `values` prop.

  import Sparkline from "./Sparkline.svelte";

  export let label: string;
  export let value: string;
  export let values: readonly number[] | null = null;
  /** Optional status: "ok" | "warn" | "err" | null. Colours the dot + value. */
  export let status: "ok" | "warn" | "err" | null = null;
  /** Optional trend direction + delta label (e.g. "+3%"). */
  export let trend: "up" | "down" | "flat" | null = null;
  export let trendLabel: string | null = null;
</script>

<article
  class="metric-card"
  data-status={status ?? undefined}
  data-testid="metric-card"
>
  <header class="metric-card__head">
    <span class="metric-card__label">{label}</span>
    {#if status}
      <span
        class="metric-card__dot"
        data-status={status}
        aria-label={status === "ok" ? "healthy" : status === "warn" ? "warning" : "unhealthy"}
      ></span>
    {/if}
  </header>
  <p class="metric-card__value" data-status={status ?? undefined}>{value}</p>
  {#if values && values.length > 0}
    <Sparkline {values} className="metric-card__sparkline" />
  {/if}
  {#if trend && trendLabel}
    <div class="metric-card__trend" data-trend={trend} aria-label={`trend ${trend}: ${trendLabel}`}>
      <span class="metric-card__trend-arrow" aria-hidden="true">
        {#if trend === "up"}↑{:else if trend === "down"}↓{:else}→{/if}
      </span>
      <span class="metric-card__trend-text">{trendLabel}</span>
    </div>
  {/if}
</article>
